import { Box } from "@mui/material";
import React from "react";

interface ClickableSectionProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  isActive?: boolean;
  [key: string]: unknown;
}

export default function ClickableSection({
  children,
  onClick,
  isActive,
  ...etc
}: ClickableSectionProps) {
  const isInteractive = !!onClick;

  return (
    <Box
      onClick={onClick}
      {...etc}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, sm: 1.25 },
        px: { xs: 1.25, sm: 1.5 },
        py: 0.75,
        borderRadius: 1,
        cursor: isInteractive ? "pointer" : "default",
        width: { xs: "100%", sm: "auto" },
        minWidth: 0,
        border: "1px solid",
        borderColor: isActive ? "primary.main" : "transparent",
        bgcolor: isActive ? "action.selected" : "transparent",
        ...(isInteractive && {
          "&:hover": { bgcolor: "action.hover", borderColor: "divider" },
        }),
        transition: "background-color 150ms, border-color 150ms",
        "& > *": {
          minWidth: 0,
        },
      }}
    >
      {children}
    </Box>
  );
}
